<template>
  <div class="drop-box" @mouseenter="spin = true" @mouseleave="spin = false">
    <div class="title">
      <span>{{ title }}</span>
      <Icon type="arrow-down-b" class="icon" :class="spin ? 'on' : ''"></Icon>
    </div>
    <transition name="slide-fade" v-if="spin">
      <div class="drog-content">
        <slot name="list"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "DropDown",
  props: {
    title: {
      type: String,
      default: "专科栏目"
    }
  },
  watch: {
    $route(to, from) {
      if (to.fullPath !== from.fullPath) {
        this.spin = false;
      }
    }
  },
  data() {
    return {
      spin: false
    };
  }
};
</script>

<style lang="stylus" scoped>
.title
  .icon
    margin-left 5px
    transform translateY(1px)
    transition all 0.3s linear
    &.on
      transform rotate(180deg)
.drog-content
  position relative
</style>
